import { Location } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

import { NotFoundModule } from "../../modules/not-found/not-found.module";

@Component({
	selector: "ic-error-page",
	imports: [NotFoundModule, TranslateModule],
	templateUrl: "./error-page.component.html",
	styleUrls: ["./error-page.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPageComponent {
	sentryId: string;

	private readonly location = inject(Location);
	private readonly router = inject(Router);

	redirectToDashboard() {
		this.location.replaceState("");
		window.location.reload();
	}

	constructor() {
		this.sentryId = this.router.getCurrentNavigation().extras.state?.eventId;
	}
}
